import eveNgCroppedImage from "public/hosted-emulators/eve-ng-cropped.webp";
import gnsImage from "public/hosted-emulators/gns.webp";
import ciscoImage from "public/customers/cisco.webp";

export const OS_IMAGES = {
  "CI-OS-EVE-NG-PRO": eveNgCroppedImage,
  "CI-OS-EVE-NG-COM": eveNgCroppedImage,
  "CI-OS-CML2-BYOL": ciscoImage,
  "CI-OS-GNS3": gnsImage,
};

export const SORT_OPTIONS = [
  // {label: "Price (Low to High)", value: "price-asc"},
  // {label: "Price (High to Low)", value: "price-desc"},
  { label: "vCPU (Low to High)", value: "config.vcpu-asc" },
  { label: "vCPU (High to Low)", value: "config.vcpu-desc" },
  { label: "Memory (Low to High)", value: "config.memory-asc" },
  { label: "Memory (High to Low)", value: "config.memory-desc" },
  { label: "SSD/NVME (Low to High)", value: "config.ssd-asc" },
  { label: "SSD/NVME (High to Low)", value: "config.ssd-desc" },
];
